export enum ActionType {
  FINAL_PL_EVALUATION_DETAILS_BY_PID = "FINAL_PL_EVALUATION_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IFinalPLEvaluationDetailsByPid {
  type: ActionType.FINAL_PL_EVALUATION_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IFinalPLEvaluationDetailsByPid | IResetReduxState;
